import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import ProductFeatureAnimation from './productFeatureAnimation/productFeatureAnimation';

global.React = React;
global.ReactDOM = ReactDOM;
global.ProductFeatureAnimation = ProductFeatureAnimation;
global.ReactDOMServer = ReactDOMServer;
